import {
  Injectable,
  Injector,
  ComponentFactoryResolver,
  EmbeddedViewRef,
  ApplicationRef,
} from '@angular/core';

import { EventService } from './event.service';
import { OverlayContainerComponent } from './overlay-container.component';
import {
  OverlayProperties,
  ContainerProperties,
  OverlayEvent,
} from './interfaces';
import { defaultProperties } from './default-properties';

@Injectable()
export class Overlay {
  globalEventsSubscription: any;
  componentRefs: any = {};
  // tslint:disable-next-line:variable-name
  _defaultProperties: any;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector,
    private eventService: EventService
  ) {
    this.globalEventsSubscription = this.eventService.emitter.subscribe(
      (event: OverlayEvent) => {
        this.handleGlobalEvents(event);
      }
    );
  }

  appendComponentToBody(
    properties: any,
    component: any = OverlayContainerComponent
  ): void {
    if (this.componentRefs[0]) {
      return;
    }

    const componentRef = this.componentFactoryResolver
      .resolveComponentFactory(component)
      .create(this.injector);

    this.componentRefs[0] = componentRef;

    (componentRef.instance as ContainerProperties).properties = properties;
    this.appRef.attachView(componentRef.hostView);
    const domElem = (componentRef.hostView as EmbeddedViewRef<any>)
      .rootNodes[0] as HTMLElement;

    // Add to body
    document.body.appendChild(domElem);
  }

  public load(properties: OverlayProperties): void {
    properties = this.applyPropertieDefaults(defaultProperties, properties);
    this.appendComponentToBody(properties);
  }

  // tslint:disable-next-line:no-shadowed-variable
  applyPropertieDefaults(
    defaultProperties: OverlayProperties,
    properties: OverlayProperties
  ) {
    if (!properties) {
      properties = {};
    }
    this._defaultProperties = Object.assign({}, defaultProperties);
    return Object.assign(this._defaultProperties, properties);
  }

  handleGlobalEvents(event: OverlayEvent) {
    if (event.type === '[Overlay] Hide') {
      this.handleCloseEvent();
    }
  }

  handleCloseEvent() {
    if (!this.componentRefs[0]) {
      return;
    }

    this.appRef.detachView(this.componentRefs[0].hostView);
    this.componentRefs[0].destroy();
    delete this.componentRefs[0];
  }
}
